import { Component } from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';

/** Last-resort boundary so a render failure never shows a blank page. */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Production: forward to the monitoring endpoint with the current request id.
    console.error('Unhandled UI error', error, info);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh', padding: 24, background: 'var(--bg-subtle)' }}>
        <div className="card" style={{ maxWidth: 440, padding: 'var(--sp-6)', textAlign: 'center' }}>
          <div className="empty__icon" style={{ margin: '0 auto var(--sp-3)', color: 'var(--danger)', background: 'var(--danger-bg)' }}>
            <AlertTriangle size={24} />
          </div>
          <h2 style={{ marginBottom: 6 }}>Something went wrong</h2>
          <p className="meta" style={{ marginBottom: 'var(--sp-4)', lineHeight: 1.6 }}>
            The page could not be displayed. Reloading usually clears this. If it keeps happening, contact IT support with the
            time it occurred.
          </p>
          <button type="button" className="btn btn--primary" onClick={() => window.location.reload()}>
            <RotateCcw size={15} />
            Reload page
          </button>
        </div>
      </div>
    );
  }
}
